import { FORM_BUILDER_FIELD_TYPE } from "@loanbossinc/component-library";

export const rows = {
  title: {
    isTitle: true,
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Insurance",
        style: {
          marginLeft: "0",
          fontFamily: "Work Sans",
          fontStyle: "normal",
          fontWeight: "500",
          fontSize: "16px",
          lineHeight: "14px",
          textTransform: "uppercase",
          color: "#000000",
          marginBottom: "10px"
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.insurance.header"
      }
    ]
  },
  requiredPolicies: {
    label: "Required Policies",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "insurance.requiredPolicies",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.insurance.requiredPolicies"
      }
    ]
  },
  mandatoryPrepayments: {
    label: "Mandatory Prepayments",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "insurance.mandatoryPrePayments",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.insurance.mandatoryPrePayments"
      }
    ]
  },
  restoration: {
    label: "Restoration",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "insurance.restoration",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.insurance.restoration"
      }
    ]
  },
  misc: {
    label: "Misc",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "insurance.misc",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.insurance.misc"
      }
    ]
  }
};
